import React from "react";
import PropTypes from "prop-types";

const Result = props => {
  const { result } = props;

  const url = `https://panfoundation.prescience.cloud/${result.mData["Entry:CategoryID"]}/${result.mData["Entry:ID"]}`;

  return (
    <li className="QuickSearch-results-item">
      <a href={url} className="QuickSearch-results-link">
        {result.mData["Entry:Part:title:Data"]}
      </a>
    </li>
  );
};

Result.propTypes = {
  result: PropTypes.object.isRequired
};

export default Result;
